<i18n>
  {
    "pt_BR": {
      "title": "Suas faturas",
      "description": "Acompanhe o estado das suas faturas!",
      "without": "Você não tem nenhuma fatura ainda =/"
    }
  }
</i18n>

<template>
  <section class="details">
    <article class="details-card">
      <template v-if="invoices">
        <header class="details-header">
          <h1 class="details-header--title" v-t="'title'"></h1>
          <p class="details-header--date" v-t="'description'"></p>
        </header>

        <invoice-table v-if="invoices.length" :invoices="invoices" />

        <template v-else>
          <div class="details-not-sent">
            <p class="details-not-sent--text" v-t="'without'"></p>
          </div>
        </template>
      </template>

      <status :status="invoices" v-else />
    </article>
  </section>
</template>

<script>
  import Status from '@/Status';
  import Axios from 'core/axios';
  import InvoiceTable from './Table';

  export default {
    components: {
      Status,
      InvoiceTable,
    },

    data: () => ({
      invoices: null,
    }),

    created () {
      this.fetch();
    },

    methods: {
      fetch () {
        return Axios.get('invoice')
          .then(({ data }) => this.invoices = data.data)
          .catch(() => this.invoices = false);
      },
    },
  };
</script>



// WEBPACK FOOTER //
// src/components/Invoice/Invoice.vue